import gql from 'graphql-tag'
export default gql`query attestQuery($id: Int!) {
  attest(id: $id) {
    attestNumber
    expirationDate
    id
  }
}`